import _ from 'lodash';
import * as moment from 'moment';
import Network from 'lib/api/network';

export default {
  namespaced: true,

  state() {
    return {
      session: null,
      flowType: null,
      primaryMembership: {
        email: null,
        personal_email: null,
        user: null,
      },
    };
  },

  mutations: {
    update(state, { key, value }) {
      state[key] = value;
    },

    updatePrimaryMembership(state, { key, value }) {
      state.primaryMembership[key] = value;
    },

    resetPrimaryMembership(state) {
      state.primaryMembership = {
        email: null,
        personal_email: null,
        user: null,
      };
    },
  },

  actions: {
    deactivateSessionEvent({ state, commit }, { event }) {
      const originalEvent = _.cloneDeep(event);
      // Initial FE removal to avoid delay
      commit('onboardingEventsCalendar/updateEvent', { eventId: event.id, data: { active: false } }, { root: true });
      return new Promise(() => {
        const url = `/${state.flowType.routeResource}/session_events/${event.id}`;
        Network.delete(url, {}, {
          success: (data) => {
            // Re-update it with value from BE, just to make sure there's no funny business
            commit('onboardingEventsCalendar/updateEvent', { eventId: event.id, data }, { root: true });
          },
          error: (error) => {
            commit('onboardingEventsCalendar/updateEvent', { eventId: event.id, data: originalEvent }, { root: true });
            dispatch('setErrorToast', null, { root: true });
          },
        });
      });
    },

    triggerSessionEvents({ state, commit, dispatch }, { events }) {
      const event = events[0];
      const remainingEvents = events.slice(1);

      commit('update', { key: 'formSubmitted', value: true }, { root: true });
      return new Promise(() => {
        const url = `/${state.flowType.routeResource}/session_events/${event.id}/trigger`;
        Network.post(url, {}, {
          success: (data) => {
            event.triggering = false;
            commit('onboardingEventsCalendar/updateEvent', { eventId: event.id, data }, { root: true });
          },
          error: (error) => {
            event.triggering = false;
            dispatch('setErrorToast', null, { root: true });
          },
          complete: () => {
            if (remainingEvents.length) {
              dispatch('triggerSessionEvents', { events: remainingEvents });
            } else {
              commit('update', { key: 'formSubmitted', value: false }, { root: true });
            }
          },
        });
      });
    },

    beginEventReschedule({ commit, dispatch }, { event, day }) {
      // Some events need a modal version to determine if rescheduling for whole cohort. Others can only
      // ever be just the full cohort, so no modal required. Note that for this reason we don't want any
      // "modal" functionality in `rescheduleEvent`. Keep it pure.
      const originalDay = event.occurs_on;
      const eventId = event.id;
      // Move the event to anticipate a successful reschedule, while keeping track of the old day for reverting
      // upon either cancellation in the modal or an unsuccessful API call
      commit('onboardingEventsCalendar/updateEvent', { eventId, data: { occurs_on: day } }, { root: true });
      commit('updateModal', {
        visible: true,
        subcomponent: 'onboarding-events-modals-apply-reschedule-to-cohort',
        data: { eventId, day, originalDay, batchOnly: event.batch_reschedulable },
        cancelAction: 'onboardingSessions/cancelEventReschedule',
        cancelArgs: { eventId, originalDay },
      }, { root: true });
    },

    cancelEventReschedule({ commit }, { eventId, originalDay }) {
      // This should only be called onCancel for the apply-reschedule-to-cohort modal, we just need one action
      // that both moves the event back to the original day and closes the modal in the same swoop
      commit('onboardingEventsCalendar/updateEvent', { eventId, data: { occurs_on: originalDay } }, { root: true });
      commit('closeModal', null, { root: true });
    },

    rescheduleEvent({ state, commit, dispatch }, { eventId, day, originalDay, rescheduleForCohort }) {
      // Keep this agnostic to any modal activity, purely functional
      commit('onboardingEventsCalendar/updateEvent', { eventId, data: { occurs_on: day } }, { root: true });
      return new Promise(() => {
        const url = `/${state.flowType.routeResource}/session_events/${eventId}/reschedule`;
        const params = { onboarding_session_event: { occurs_at: day, reschedule_for_cohort: rescheduleForCohort } };
        Network.put(url, params, {
          success: () => {
            // Re-update it with value from BE, just to make sure there's no funny business
            commit('onboardingEventsCalendar/updateEvent', { eventId, data: { occurs_on: day } }, { root: true });
            if (rescheduleForCohort) dispatch('setSuccessToast', 'Successfully applied to full cohort!', { root: true });
          },
          error: (error) => {
            // Revert the move in case of failure
            const toastCopy = error?.responseJSON?.error;
            commit('onboardingEventsCalendar/updateEvent', { eventId, data: { occurs_on: originalDay } }, { root: true });
            dispatch('setErrorToast', toastCopy, { root: true });
          },
        });
      });
    },
  },
};
